import React from 'react';
import SceneController from './SceneController';

export default class Home extends React.Component {

    componentDidMount() {
        this.threeRootElement.style.outline = 'none';
        this.sceneController = new SceneController(this.threeRootElement);
        this.addEventListeners();
        this.sceneController.setup();
        this.update();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
        document.removeEventListener("mousemove", this.onDocumentMouseMove);
        if (this.sceneController) this.sceneController.dispose();
    };

    addEventListeners() {
        window.addEventListener('resize', this.onWindowResize, false);
        document.addEventListener("mousemove", this.onDocumentMouseMove, false);
    };

    onWindowResize = () => {
        if (this.sceneController) {
            this.sceneController.onWindowResize();
            this.sceneController.update();
        }
    };

    onDocumentMouseMove = (e) => {
        if (this.sceneController) this.sceneController.onMouseMove(e);
    }

    update = () => {
        requestAnimationFrame(this.update);
        if (this.sceneController) this.sceneController.update();
    };

    render() {
        return (
            <div ref={element => this.threeRootElement = element}>
                <Text />
            </div>
        );
    }
};

const Text = () => {
    return (
        <div className="Info">
            Liquid Body
            <br />
            MOVE MOUSE
        </div>
    );
}